import * as React from 'react';

function ModalErro({ handleModalErro }) {
    return (
        <div id="modalErro" className="bundleTela bundleBackgroundPopup" style={{ "marginTop": "50px" }}>
            <div className="bundleBox2">
                <label className="bundleTitulo bundleCentro">
                    Erro ao validar seu acesso
                </label>
                <span id="linkCloseModalError" className="close" onClick={() => handleModalErro(false)}>&times;</span>
                <label className="bundleLabelPopup1">
                    <p>Entre em contato com o seu corretor ou com nossos canais de atendimento, <br />
                    que você pode encontrar no e-mail que te trouxe até aqui.</p>
                </label>
            </div>
        </div >
    );
}

export default ModalErro;